import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
import { UPDATE_DROP_MNEMONIC_ID } from 'root/src/shared/descriptions/endpoints/endpointIds';
export const updateDropMnemonicId = {
    [UPDATE_DROP_MNEMONIC_ID]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
    },
};
